import { Box } from "@mui/material";
import useUser from "../../../hooks/useUser";
import useLogo from "../hooks/useLogo";

export default function Logo() {
  const logo = useLogo();
  const { roles } = useUser();
  if (roles.master) {
    return null;
  }
  if (logo) {
    return (
      <Box justifyContent={"center"} alignItems={"center"} display={"flex"}>
        <img
          src={logo}
          alt="Logo"
          className="logo"
          style={{
            width: "200px",
          }}
        />
      </Box>
    );
  }
}
